<template>
  <div
    class="formCountInput"
    :class="[
      'formCountInput',
      validateCount ? 'formCountInput--error' : '',
      missingQuantity && showMissingQuantity
        ? 'formCountInput--error formCountInput--marginLeft'
        : '',
    ]"
  >
    <div class="formCountInput__valuesWrapper">
      <div class="formCountInput__values">
        <span v-if="missingQuantity && showMissingQuantity" class="formCountInput__available">
          <span class="formCountInput__availableIcon icon-check-border" />{{
            quantity - missingQuantity
          }}</span
        >
        <span v-if="missingQuantity && showMissingQuantity" class="formCountInput__missing"
          ><span class="formCountInput__availableIcon icon-wrong" />{{ missingQuantity }}</span
        >
      </div>
      <span v-if="dateDeliveryInsufficientStock" class="formCountInput__availableDate"
        >dostępny od {{ dateDeliveryInsufficientStock }}</span
      >
    </div>
    <input
      type="number"
      :value="value"
      placeholder="0"
      :disabled="disabled"
      class="formCountInput__input"
      @input="onInput"
      @keyup.enter="onEnter"
    />
    <div class="formCountInput__count">
      <span class="formCountInput__countNumber">
        {{ value }}
      </span>
      <span
        class="formCountInput__countText"
        :class="{ 'formCountInput__countText--empty': value === '' }"
      >
        {{ uom }}
      </span>
    </div>
    <div class="formCountInput__action">
      <button
        :disabled="disabled"
        :class="[
          'formCountInput__actionButton',
          { 'formCountInput__actionButton--disable': disabled },
        ]"
        @click="plus()"
      >
        +
      </button>
      <button
        :disabled="value <= iterationValue"
        :class="[
          'formCountInput__actionButton',
          { 'formCountInput__actionButton--disable': value <= iterationValue || disabled },
        ]"
        @click="minus()"
      >
        -
      </button>
    </div>
    <div v-if="group > 1 && !disableMultipleButton" class="formCountInput__group">
      <button :disabled="disabled" class="formCountInput__groupInner" @click="groupPlus">
        +{{ group }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCountInput',
  props: {
    group: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 1,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showMissingQuantity: {
      type: Boolean,
      default: false,
    },
    quantityMultiple: {
      type: Boolean,
      default: false,
    },
    missingQuantity: {
      type: Number,
      default: null,
    },
    dateDeliveryInsufficientStock: {
      type: String,
      default: '',
    },
    disableMultipleButton: {
      type: Boolean,
      default: false,
    },
    uom: {
      type: String,
      default: 'szt.',
    },
  },
  data() {
    return {
      validateCount: false,
      currentCount: this.value,
    };
  },
  computed: {
    iterationValue() {
      if (this.quantityMultiple) {
        return this.group;
      } else {
        return 1;
      }
    },
    minValue() {
      if (this.quantityMultiple) {
        return this.group;
      } else {
        return 1;
      }
    },
  },
  watch: {
    value(newVal) {
      this.validateCount = !!(this.quantityMultiple && newVal % this.group);
    },
  },
  methods: {
    onEnter() {
      this.$emit('enter');
    },
    onInput(e) {
      if (e.target.value === '') this.$emit('input', 0);
      else this.$emit('input', parseInt(e.target.value));
      this.$forceUpdate();
    },
    plus() {
      this.$emit(
        'input',
        Math.floor((this.value + this.iterationValue) / this.iterationValue) * this.iterationValue,
      );
    },
    minus() {
      if (this.value >= this.minValue) {
        this.$emit(
          'input',
          Math.ceil((this.value - this.iterationValue) / this.iterationValue) * this.iterationValue,
        );
      }
    },
    groupPlus() {
      if (this.value === 1) {
        this.$emit('input', this.group);
      } else {
        this.$emit('input', this.value + this.group);
      }
    },
  },
};
</script>

<style lang="scss">
.formCountInput {
  $root: &;
  position: relative;
  display: inline-flex;
  border: 1px solid $cAddLight;
  border-radius: 3px;

  &__input {
    height: 4.6rem;

    width: 8.8rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 600;
    overflow: hidden;

    @include rwd('small-phone') {
      width: 6.8rem;
    }

    &::placeholder {
      color: $cMainDark;
      font-weight: 600;
    }

    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }

  &__valuesWrapper {
    pointer-events: none;
    @include rwd('small-tablet') {
      width: 100%;
      position: absolute;
      bottom: -46px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      transition: left $tr;

      @include rwd('large-phone') {
        bottom: -52px;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }

  &__values {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @include rwd('large-laptop') {
      position: absolute;
      top: -28px;
    }
    @include rwd('small-tablet') {
      position: static;
      top: auto;
    }
  }

  &__availableDate {
    position: absolute;
    bottom: -28px;
    left: 0;

    @include rwd('small-tablet') {
      position: static;
      left: auto;
      bottom: auto;
      margin-left: 1rem;
    }

    @include rwd('large-phone') {
      margin-left: 0;
    }
  }

  &__action {
    position: relative;
    z-index: 1;
    background-color: $cWhite;
    display: flex;
    flex-direction: column;
    width: 2.2rem;
    border-left: 1px solid $cAddLight;
  }

  &__count {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 600;
    pointer-events: none;
    white-space: nowrap;
    max-width: calc(100% - 2rem);
    overflow: hidden;
  }

  &__countText {
    &--empty {
      padding-left: 1.1rem;
    }
  }

  &__countNumber {
    opacity: 0;
  }

  &__actionButton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50%;
    color: $cMainDark;
    font-size: 1.6rem;
    font-weight: 700;
    border-top: 1px solid $cAddLight;
    cursor: default;
    transition: color $tr, background-color $tr;

    &:first-child {
      border-top: 0;
    }

    &--disable {
      color: $cAddDark02;
    }

    &:not(#{$root}__actionButton--disable) {
      cursor: pointer;

      &:hover {
        background-color: $cMain;
        color: $cWhite;
      }
    }
  }

  &__group {
    position: relative;
    z-index: 1;
    background-color: $cWhite;
    padding: 0.4rem;
    border-left: 1px solid $cAddLight;
  }

  &__groupInner {
    height: 100%;
    padding: 0.5rem 0.7rem;
    background-color: $cLightMain;
    color: $cMain;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 700;
    border-radius: 3px;
    transition: background-color $tr, color $tr;

    &:hover {
      background-color: $cMain;
      color: $cWhite;
    }
  }

  &__available,
  &__missing {
    position: absolute;
    left: -9px;
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 700;
    transform: translate(-100%);

    @include rwd('large-laptop') {
      position: static;
      left: auto;
      transform: none;
    }
  }

  &__available {
    top: -1px;
    color: $cBadgeBest;

    @include rwd('large-laptop') {
      top: auto;
      margin-right: 1rem;
    }
  }

  &__missing {
    bottom: -1px;
    color: $cBadgeProm;

    @include rwd('large-laptop') {
      bottom: auto;
    }
  }

  &__availableIcon {
    font-size: 1.6rem;
    padding-right: 4px;
  }

  &--error {
    border: 1px solid $cSec;
    #{$root}__input {
      background-color: rgba($cSec, 0.1);
      color: $cBadgeProm;
      font-weight: 600;
    }

    #{$root}__count {
      color: $cBadgeProm;
      font-weight: 600;
    }
  }

  &--marginLeft {
    margin-left: 35px;

    @include rwd('small-tablet') {
      margin-left: 0;
    }
  }
}
</style>
